import { TreeNode } from 'store/graphs/types';

function buildTreeNodeKey(node: TreeNode) {
  return node.node.join('/');
}
export default buildTreeNodeKey;
